/**
 * Expert Carousel Block Fragment
 *
 * This fragment defines the fields queried for an expert-carousel block.
 */

import { defineQuery } from 'next-sanity'

/**
 * Field projection for expert-carousel
 * Can be interpolated into larger queries
 */
export const expertCarouselFields = `
  _id,
  _type,
  title,
  subTitle,
  items[]->{
    _type,
    name,
    speciality,
    description,
    image
  }
`

/**
 * Complete query for a single expert-carousel block
 * Used by TypeGen to generate EXPERT_CAROUSEL_QUERY_RESULT type
 */
export const EXPERT_CAROUSEL_QUERY = defineQuery(/* groq */ `
  *[_type == "expert-carousel"][0]{
    ${expertCarouselFields}
  }
`)
